<template>
  <v-flex class="transferFunds fill-height" data-qa="transferfunds-flex-wggrb">
    <ConfirmExit
      v-if="isLeavingRoute"
      v-on:isLeavingRoute="proceedLeave"
      v-on:isNotLeavingRoute="cancelLeave"
    />
    <Loader v-show="loaderEnabled"/>
    <v-flex v-if="createScreen" xs12 sm12 md12 lg12 xl12 data-qa="transferfunds-flex-3z5gx2">
      <v-navigation-drawer
        v-model="openPayee"
        :width="360"
        :close-on-click="false"
        absolute
        bottom
        right
        floating
        class="transferFunds--payeeList"
       data-qa="transferfunds-navigation-drawer-a7or24">
        <v-card height="100%" data-qa="transferfunds-card-kv45xm">
          <template v-if="!enablePayeeForm">
            <v-toolbar color="white" light data-qa="transferfunds-toolbar-tuzhnc">
              <v-toolbar-title data-qa="transferfunds-toolbar-title-bvdz3"  v-text="text.selectPayeeLabel" />
              <v-spacer data-qa="transferfunds-spacer-s09ok6"  />
              <v-btn
                icon
                @click.stop="openPayee = !openPayee"
               data-qa="transferfunds-btn-gszfyb">
                <v-icon class="material-symbols-outlined" data-qa="transferfunds-icon-0vop0l">close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider data-qa="transferfunds-divider-67dygnh"  />
            <v-tabs
              v-if="!appSettings.enableTransferFundsOnlyToOwnAccounts"
              v-model="payeeCurrentTab"
              align-with-title
              :color="primaryColor"
              @change="onPayeeTabChanged"
             data-qa="transferfunds-tabs-f1yp8d">
              <v-tabs-slider :color="primaryColor" data-qa="transferfunds-tabs-slider-3azwc"></v-tabs-slider>
              <v-tab
                v-for="(item, i) in totalPayeeTabs"
                :key="item"
                class="text-capitalize font-weight-bold"
                :data-qa="`transferfunds-tab-xkp33q-${i}`"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="payeeCurrentTab" :color="primaryColor" data-qa="transferfunds-tabs-items-xkp62q">
              <v-tab-item data-qa="transferfunds-tab-item-x8z24i">
                <TransferFundsOwnAccountPayeeList
                  v-if="isOwnAccountsOpted"
                  :payor="selectedAccount"
                  :payeeList="listOfAccounts"
                  :isRecurring="isRecurring"
                  :isFutureDated="isFutureDated"
                  @payee-selected="onOwnAccountPayeeSelected"
                />
              </v-tab-item>
              <v-tab-item data-qa="transferfunds-tab-item-mqdjdj">
                <TransferFundsIntrabankPayeeList
                  v-if="!isOwnAccountsOpted"
                  :beneficiaryList="beneficiaryList"
                  @payee-selected="onIntrabankPayeeSelected"
                  @open-add-new-payee="enablePayeeForm = true"
                />
              </v-tab-item>
            </v-tabs-items>
          </template>
          <TransferFundsAddNewPayee
            v-else
            @close-add-new-payee="enablePayeeForm = false"
            @add-payee="onAddPayee"
          />
        </v-card>
      </v-navigation-drawer>
      <v-flex xs12 sm12 md12 lg12 xl12 data-qa="transferfunds-flex-pvmxa9">
        <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="transferfunds-layout-639pnq">
          <v-flex
            xs12
            sm12
            md12
            lg12
            xl12
            :style="{ background: dashboardGradient, height: '180px' }"
           data-qa="transferfunds-flex-3skmsf">
            <v-container class="transferFunds--title-padding" data-qa="transferfunds-container-5m1oh0d">
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="transferfunds-flex-f3tkum">
                <v-row no-gutters data-qa="transferfunds-row-uh5kv">
                  <v-layout row wrap class="pb-2" data-qa="transferfunds-layout-jywcqq">
                    <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="transferfunds-flex-a6q2g">
                      <v-row justify="end" data-qa="transferfunds-row-nyza9v">
                        <v-avatar :tile="false" size="35" color="white" data-qa="transferfunds-avatar-unm5ff">
                          <!-- <v-icon :color="primaryColor" data-qa="transferfunds-icon-q5xfq">mdi-sync</v-icon> -->
                          <dob-icon iconKey="transferfunds_bannerIcon" />
                        </v-avatar>
                      </v-row>
                    </v-flex>
                    <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="transferfunds-flex-tmrqiq">
                      <v-row no-gutters data-qa="transferfunds-row-lheifm">
                        <font class="text-h5 font-weight-light white--text">
                          {{ $t("transferfunds.title") }}</font
                        >
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-row>
              </v-flex>
            </v-container>
          </v-flex>
        </v-layout>

        <v-flex
          xs12
          sm12
          md12
          lg10
          xl10
          class="transferFunds--content-padding transferFunds--overlayCardFlex"
         data-qa="transferfunds-flex-pganofd">
          <v-layout row wrap class="transferFunds--content-padding" data-qa="transferfunds-layout-qexl7">
            <v-flex xs12 sm11 md10 lg10 xl10 class="pt-4" data-qa="transferfunds-flex-xqhe0w">
              <v-card :class="enableQuickPay ? '' : 'pt-4'" data-qa="transferfunds-card-1b5j2t">
                <v-tabs
                  v-if="enableQuickPay"
                  v-model="currentTab"
                  :color="primaryColor"
                  class="pl-8 pt-4 pb-4"
                  @change="onPaymentTabChanged"
                 data-qa="transferfunds-tabs-4vhuqs">
                  <v-tabs-slider
                    :color="primaryColor"
                   data-qa="transferfunds-tabs-slider-4yx7f9"></v-tabs-slider>
                  <v-tab
                    v-for="(item, i) in totalFundTabs"
                    :key="item"
                    class="text-capitalize font-weight-bold"
                    @click="managePayee = false"
                    :data-qa="`transferfunds-tab-4vhuqs-${i}`"
                  >
                    {{ item }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="currentTab" :color="primaryColor" data-qa="transferfunds-tabs-items-hsoph8">
                  <v-card data-qa="transferfunds-card-g5rasp">
                    <!-- 1st Tab - Resgistered Account -->
                    <v-tab-item data-qa="transferfunds-tab-item-gcvw9k">
                      <v-container class="pt-0" data-qa="transferfunds-container-r7ar2">
                        <v-tabs
                          v-if="currentTab !== 1 && enableRecurringPaymentsOption"
                          v-model="paymentMode"
                          :color="primaryColor"
                          class="pl-5"
                          @change="handlePaymentModeChange"
                         data-qa="transferfunds-tabs-ayxsci">
                          <v-tab @click="resetPage" data-qa="transferfunds-tab-ptwl735">
                            <font class="text-capitalize">{{
                              $t("transferfunds.firstSubSection")
                            }}</font>
                          </v-tab>
                          <v-tab @click="resetPage" data-qa="transferfunds-tab-tj0yd">
                            <font class="text-capitalize">{{
                              $t("transferfunds.secondSubSection")
                            }}</font>
                          </v-tab>
                        </v-tabs>
                        <v-form
                          ref="form"
                          v-model="isFormValid"
                          :lazy-validation="false"
                         data-qa="transferfunds-form-gy3p29">
                          <v-layout row justify-space-between data-qa="transferfunds-layout-skz7g">
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="transferfunds-flex-6jbott">
                              <!-- From Account -->
                              <PaymentSourceSelect
                                v-model="form.selectedAccount"
                                @input="verifyAccount"
                                :items="filteredSourceAccounts"
                                :label="text.selectAccountLabel"
                                :error="isFormAccounts"
                                :error-messages="isFormAccounts ? $t('transferfunds.accountsError') : ''"
                                :rules="[rules.requiredRule || !isFormAccounts]"
                              />
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="transferfunds-flex-fpfm8b">
                              <!-- To Account -->
                              <v-text-field
                                v-model="toAccount"
                                @focus="listPayee"
                                :color="primaryColor"
                                :hint="payeeList ? payeeList : ''"
                                :rules="[rules.requiredRule || !isFormAccounts]"
                                :label="text.selectPayeeLabel"
                                filled
                                readonly
                                persistent-hint
                                append-icon="mdi-chevron-right"
                                class="transferFunds--custom-textfield"
                                @keydown="
                                  $formatter.validateNumberInput($event)
                                "
                               data-qa="transferfunds-text-field-c0cwrn"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="transferfunds-flex-uhgiqu">
                              <!-- Amount -->
                              <v-text-field
                                v-model="transferAmount"
                                @input="
                                  verifyBalance();
                                  restrictDecimal($event);
                                "
                                @keydown="restrictCharacters($event);"
                                :label="$t('transferfunds.amountLabel')"
                                :prefix="
                                  selectedAccountNumber
                                    ? $formatter.currency.getCurrencySymbol(
                                        selectedAccountNumberCurrency
                                      )
                                    : ''
                                "
                                :color="primaryColor"
                                :rules="[
                                  rules.requiredAmountRule,
                                  rules.isAccBalanceValid,
                                  rules.invalidAmount
                                ]"
                                :class="[
                                  'transferFunds--custom-textfield custom-amount',
                                  'transferFunds--amountCurrencySymbolDefault',
                                  transferAmount && transferAmount.length
                                    ? false
                                    : 'transferFunds--amountCurrencySymbol',
                                ]"
                                filled
                                type="text"
                               data-qa="transferfunds-text-field-9aoq4">
                                <template v-slot:append v-if="isLisa(selectedAccountType)">
                                  <TransferFundsLisaTooltip />
                                </template>
                              </v-text-field>
                            </v-flex>
                            <v-flex
                              v-if="isRecurring"
                              xs12
                              sm12
                              md6
                              lg6
                              xl6
                              class="px-6 pt-3"
                             data-qa="transferfunds-flex-pn7u6g">
                              <!-- Frequency -->
                              <v-select
                                v-model="paymentFrequency"
                                :label="$t('transferfunds.frequencyDaysLabel')"
                                :items="frequencyDays"
                                :color="primaryColor"
                                :rules="[rules.requiredRule]"
                                autocomplete
                                return-object
                                filled
                                item-text="state"
                                item-value="val"
                                item-key="val"
                                max-height="auto"
                                data-qa="paymentFrequency"
                                class="transferFunds--custom-textfield"
                              ></v-select>
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md6
                              lg6
                              xl6
                              class="px-6 pt-3"
                              v-if="isOneTime"
                             data-qa="transferfunds-flex-g6ar9i">
                              <!-- Date -->
                              <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                offset-y
                                transition="scale-transition"
                                :min-width="isPaymentDateEditAllowed ? '290px' : '0px'"
                               data-qa="transferfunds-menu-u012xch">
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-on="on"
                                    v-model="formattedDate"
                                    :label="
                                      isOneTime || currentTab === 1
                                        ? $t(
                                            'transferfunds.quickPaymentDateLabel'
                                          )
                                        : $t('transferfunds.paymentDateLabel')
                                    "
                                    :color="primaryColor"
                                    :rules="[rules.requiredRule]"
                                    filled
                                    readonly
                                    data-qa="fromDate"
                                    :append-icon="isPaymentDateEditAllowed ? 'mdi-calendar' : ''"
                                    class="transferFunds--custom-textfield"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-if="isPaymentDateEditAllowed"
                                  v-model="fromDate"
                                  @input="menu = false"
                                  :allowed-dates="allowedDates"
                                  :min="minAllowedDate"
                                  :color="primaryColor"
                                  @change="updateDate"
                                  filled
                                  data-qa="fromDate"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md6
                              lg6
                              xl6
                              class="px-6 pt-3"
                              v-if="isRecurring"
                             data-qa="transferfunds-flex-zmxec7">
                              <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                offset-y
                                transition="scale-transition"
                                min-width="290px"
                               data-qa="transferfunds-menu-1r0zys">
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-on="on"
                                    v-model="repeatFromDate"
                                    :label="
                                      isOneTime || currentTab === 1
                                        ? $t(
                                            'transferfunds.quickPaymentDateLabel'
                                          )
                                        : $t('transferfunds.paymentDateLabel')
                                    "
                                    :color="primaryColor"
                                    :rules="[rules.requiredRule]"
                                    filled
                                    readonly
                                    data-qa="fromDate"
                                    append-icon="mdi-calendar"
                                    class="transferFunds--custom-textfield"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="repeatFormattedDate"
                                  @input="menu = false"
                                  :allowed-dates="allowedDates"
                                  :min="repeatMinAllowedDate"
                                  :color="primaryColor"
                                  filled
                                  data-qa="fromDate"
                                  @change="repeatUpdateDate"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md6
                              lg6
                              xl6
                              class="px-6 pt-3"
                              v-if="isRecurring"
                             data-qa="transferfunds-flex-0vwz4p">
                              <!-- No. of Payments -->
                              <v-text-field
                                v-model="frequencyMonths"
                                :label="$t('transferfunds.selectTimes')"
                                :rules="[
                                  rules.requiredRule,
                                  rules.minValue,
                                  rules.maxValue,
                                ]"
                                :color="primaryColor"
                                onCopy="return false"
                                onpaste="return false"
                                @keydown="filterKey"
                                filled
                                type="number"
                                class="transferFunds--custom-textfield"
                               data-qa="transferfunds-text-field-2xjjlc"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="transferfunds-flex-yn5n86">
                              <!-- Remarks -->
                              <v-text-field
                                v-model="transferNote"
                                :label="$t('transferfunds.noteLabel')"
                                :color="primaryColor"
                                :rules="[rules.remarksLengthRule, rules.remarksFieldRule,rules.requiredRule]"
                                filled
                                class="transferFunds--custom-textfield"
                               data-qa="transferfunds-text-field-xoxsx"></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-between data-qa="transferfunds-layout-12kars">
                            <v-flex xs11 sm11 md5 lg5 xl5 class="pl-4 py-2" data-qa="transferfunds-flex-j1thmc">
                              <v-btn
                                @click="[...sameTypeTaxAcc, 'NACC', 'TXNA'].includes(selectedAccountType) ? handleModalDisplay(selectedAccountType) : nextValidate()"
                                :color="primaryColor"
                                :disabled="
                                  !isFormValid ||
                                  isFormAccounts ||
                                  isAccountBalance
                                "
                                elevation="2"
                                class="text-capitalize ma-2 white--text"
                                 data-qa="transferfunds-btn-7x5">{{
                                  $t("transferfunds.reviewPaymentBtn")
                                }}</v-btn
                              >
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </v-container>
                    </v-tab-item>
                    <!-- 2nd Tab - Quick Payment -->
                    <v-tab-item data-qa="transferfunds-tab-item-igm07">
                      <v-container class="pt-0" data-qa="transferfunds-container-nlpnm">
                        <v-form
                          ref="quickPaymentForm"
                          v-model="quickPayment.isFormValid"
                          :lazy-validation="false"
                         data-qa="transferfunds-form-z8b3ba">
                          <v-layout row justify-space-between data-qa="transferfunds-layout-dkdrz">
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="transferfunds-flex-fij12p">
                              <PaymentSourceSelect
                                v-model="form.quickSelectedAccount"
                                @input="validateQuickPaymentForm"
                                :items="filteredSourceAccounts"
                                :label="text.selectAccountLabel"
                                :error="isFormAccountsQP"
                                :error-messages="isFormAccountsQP ? $t('transferfunds.accountsError') : ''"
                                :rules="[rules.requiredRule || !isFormAccountsQP]"
                              />
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-4" data-qa="transferfunds-flex-gz93ofy">
                              <v-text-field
                                v-model="quickPayment.formattedDate"
                                :color="primaryColor"
                                :label="
                                  $t('transferfunds.quickPaymentDateLabel')
                                "
                                :rules="[rules.requiredRule]"
                                readonly
                                class="transferfunds--nonEditable-textfield"
                               data-qa="transferfunds-text-field-hpjqu"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="transferfunds-flex-0jqpet">
                              <v-text-field
                                v-model="quickPayment.toAccount"
                                :label="text.selectPayeeLabel"
                                :color="primaryColor"
                                @input="verifyAccount('toAccount')"
                                :error="isCashISAAccount || isInactiveNoticeCashISA || quickPayment.isAccountInvalid || Boolean(quickPaymentToAccountErrorMsg)"
                                :error-messages="quickPaymentToAccountErrorMsg"
                                :rules="[
                                  rules.requiredRule,
                                  rules.isAlphaNumericRule,
                                ]"
                                :maxlength="quickPayment.toAccMaxLength"
                                filled
                                type="password"
                                onCopy="return false"
                                onpaste="return false"
                                class="transferFunds--custom-textfield"
                                @keydown="
                                  $formatter.validateNumberInput($event)
                                "
                                @blur="verifyQuickPaymentPayee"
                               data-qa="transferfunds-text-field-t9zg9h"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="transferfunds-flex-nj0nm">
                              <v-text-field
                                v-model="quickPayment.reEnteredToAccount"
                                :label="text.reEnterToAccLabel"
                                :color="primaryColor"
                                :rules="[rules.requiredRule]"
                                :error="
                                  isNumberMatched(
                                    quickPayment.toAccount,
                                    quickPayment.reEnteredToAccount
                                  )
                                "
                                :error-messages="
                                  isNumberMatched(
                                    quickPayment.toAccount,
                                    quickPayment.reEnteredToAccount
                                  )
                                    ? $t('transferfunds.errorMsgAccNumMatch')
                                    : ''
                                "
                                :maxlength="quickPayment.toAccMaxLength"
                                filled
                                onCopy="return false"
                                onpaste="return false"
                                class="transferFunds--custom-textfield"
                                @keydown="
                                  $formatter.validateNumberInput($event)
                                "
                               data-qa="transferfunds-text-field-ud2g9e"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="transferfunds-flex-l8s8f4">
                              <v-text-field
                                v-model="quickPayment.transferAmount"
                                @input="
                                  verifyBalance();
                                  restrictDecimalForQuickPay($event);
                                "
                                @keydown="restrictCharacters($event);"
                                :label="$t('transferfunds.amountLabel')"
                                :color="primaryColor"
                                :rules="[
                                  rules.requiredAmountRule,
                                  rules.isQuickPaymentBalanceValid,
                                ]"
                                :prefix="
                                  quickPayment.selectedAccountNumber
                                    ? $formatter.currency.getCurrencySymbol(
                                        selectedAccountNumberCurrency
                                      )
                                    : ''
                                "
                                :class="[
                                  'transferFunds--custom-textfield custom-amount',
                                  'transferFunds--amountCurrencySymbolDefault',
                                  quickPayment.transferAmount &&
                                  quickPayment.transferAmount.length
                                    ? false
                                    : 'transferFunds--amountCurrencySymbol',
                                ]"
                                filled
                                type="text"
                               data-qa="transferfunds-text-field-iids19">
                              <template v-slot:append v-if="isLisa(quickPayment?.selectedAccount?.accountType)">
                                <TransferFundsLisaTooltip />
                              </template>
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="transferfunds-flex-n5rzva">
                              <v-text-field
                                v-model="quickPayment.transferNote"
                                :label="$t('transferfunds.noteLabel')"
                                :color="primaryColor"
                                :rules="[rules.remarksLengthRule, rules.remarksFieldRule]"
                                filled
                                class="transferFunds--custom-textfield"
                               data-qa="transferfunds-text-field-3ztqv"></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-between data-qa="transferfunds-layout-u137d">
                            <v-flex xs11 sm11 md5 lg5 xl5 class="pl-4 py-2" data-qa="transferfunds-flex-nxa5g">
                              <v-btn
                                class="text-capitalize ma-2 white--text"
                                :color="primaryColor"
                                :disabled="
                                  !quickPayment.isFormValid ||
                                  isFormAccountsQP ||
                                  quickPayment.isAccountBalance
                                "
                                elevation="2"
                                @click="[...sameTypeTaxAcc, 'NACC', 'TXNA'].includes(quickPayment.selectedAccount.accountType) ? handleModalDisplay(quickPayment.selectedAccount.accountType) : nextValidate('quickPayment')"
                                 data-qa="transferfunds-btn-fshfi">{{
                                  $t("transferfunds.reviewPaymentBtn")
                                }}</v-btn
                              >
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </v-container>
                    </v-tab-item>
                  </v-card>
                </v-tabs-items>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-flex>
    <v-flex v-if="reviewScreen" data-qa="transferfunds-flex-6alh1b">
      <TransferFundsReview
        @refreshAccounts="handleRefresh"
        :config="{ payload }"
        :display="{ viewOnly }"
      />
    </v-flex>
    <Modal
      v-if="enableOTPToAddPayee && showOTPScreen"
      @cancel="onOtpModalClose"
      :config="modalConfig.otp"
    >
      <span slot="modalContent" data-qa="transferfunds-span-27f0kr">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <!-- Acknowledgement Confirmation for all CASA transfer from Cash ISA account-->
    <Modal
      v-if="confirmTXSVTransfer"
      :config="modalConfig.ackTXSV"
      @btn1Action="handleModalClose"
    >
      <span v-if="confirmTXSVTransfer" slot="modalContent" class="font-weight-bold" data-qa="transferfunds-span-qr9o3">
        {{ $t('transferfunds.ackConfirmMsg') }} <br data-qa="transferfunds-br-fv4xfc"><br data-qa="transferfunds-br-vss1mo"> {{ $t('transferfunds.ackQn') }}
      </span>
      <span v-else slot="modalContent" class="font-weight-bold" data-qa="transferfunds-span-dlgr7">
        {{ $t('closeAccount.lossOfInterestWarning', { currency: $formatter.currency.getCurrencySymbol(penaltyDetails?.chargeAmount?.currency || selectedAccountNumberCurrency), amount: chargeAmt }) }}
      </span>
    </Modal>
    <!-- TXNA/TXFR Error - Subscription amount exceeded -->
    <Modal
      v-if="exceededTXNASubAmt || exceededTXFRSubAmt"
      :config="modalConfig.exceedISA"
      @btn1Action="handleModalClose"
    >
      <span v-if="exceededTXNASubAmt" slot="modalContent" class="font-weight-bold" data-qa="transferfunds-span-lzahi">
        {{ $t('transferfunds.txnaErrorL1') }}<br data-qa="transferfunds-br-5bgzxc"><br data-qa="transferfunds-br-imz0f">{{ $t('transferfunds.txnaErrorL2') }}
      </span>
      <span v-if="exceededTXFRSubAmt" slot="modalContent" class="font-weight-bold" data-qa="transferfunds-span-vv3ll">
        {{ $t('transferfunds.txfrErrorL1') }}<br data-qa="transferfunds-br-lsbw1"><br data-qa="transferfunds-br-dz930p">{{ $t('transferfunds.txnaErrorL2') }}
      </span>
    </Modal>
    <NoticeCashIsaWarning
      v-if="confirmNACCTransfer"
      :subtitle="$t('transferfunds.withdrawImmediately')"
      :text="lossOfInterestWarning"
      @onCancel="handleModalClose"
      @onContinue="handleNoticeWarningContinuation"
    />
  </v-flex>
</template>

<script>
import '@/styles/pages/login/login.scss'
import '@/styles/pages/transferFunds.scss'
import OtpInput from '@/components/common/OtpInput.vue'
import commonService from '@/service/commonService.js'
import preload from '@/util/preload'
import event from '@/util/event'
import TransferFundsReview from './TransferFundsReview.vue'
import moment from 'moment'
import store from '@/core/store'
import Loader from '../../../components/common/Loader.vue'
import { formatSelectedAccount, formatSelectedHint } from '../../../util/accountUtil'
import PaymentSourceSelect from '../../common/PaymentSourceSelect.vue'
import smeRolesMixin from '@/core/mixins/smeRolesMixin.js'

export default {
  name: 'TransferFunds',
  components: {
    Loader,
    OtpInput,
    TransferFundsReview,
    Modal: () => import('@/components/common/Modal.vue'),
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue'),
    TransferFundsLisaTooltip: () => import('./TransferFundsLisaTooltip.vue'),
    NoticeCashIsaWarning: () => import('@/views/accounts/accountDetails/noticeCashISA/NoticeCashIsaWarning.vue'),
    TransferFundsAddNewPayee: () => import('./TransferFundsAddNewPayee.vue'),
    TransferFundsIntrabankPayeeList: () => import('./TransferFundsIntrabankPayeeList.vue'),
    TransferFundsOwnAccountPayeeList: () => import('./TransferFundsOwnAccountPayeeList.vue'),
    PaymentSourceSelect
  },
  mixins: [smeRolesMixin],
  data () {
    return {
      isCashISAAccount: false,
      isInactiveNoticeCashISA: false,
      exceededTXNASubAmt: false,
      exceededTXFRSubAmt: false,
      toAccountDesc: '',
      confirmTXSVTransfer: false,
      confirmNACCTransfer: false,
      chargeAmt: 0,
      penaltyDetails: {},
      sameTypeTaxAcc: ['TXEA', 'TXSV'],
      filteredItems: [],
      toAccountType: '',
      quickPaymentToAccountErrorMsg: '',
      valid: true,
      createScreen: true,
      reviewScreen: false,
      isFormValid: false,
      isFormAccounts: false,
      isFormAccountsQP: false,
      isAccountBalance: false,
      loaderEnabled: false,
      openPayee: false,
      enablePayeeForm: false,
      menu: false,
      search: '',
      listOfAccounts: [],
      payload: {},
      viewOnly: {},
      isLeavingRoute: false,
      selectedAccount: undefined,
      selectedPayee: null,
      selectedAccountNumber: '',
      selectedAccountNumberCurrency: '',
      selectedAccountType: '',
      payeeAccount: '',
      selectPayee: '',
      transferAmount: [],
      paymentFrequency: '',
      frequencyMonths: '',
      transferNote: '',
      payeeList: '',
      toAccount: '',
      fromDate: moment().format('YYYY-MM-DD'),
      repeatFromDate: moment().format('YYYY-MM-DD'),
      todaysDate: moment().format('YYYY-MM-DD'),
      minAllowedDate: moment().format('YYYY-MM-DD'),
      repeatMinAllowedDate: moment().format('YYYY-MM-DD'),
      accruedPenaltyCharges: this.$appSettings.defaultConfigurations.enableAccruedPenaltyCharges,
      enableOTPToAddPayee:
        this.$appSettings.defaultConfigurations.enableOTPToAddIntraBankPayee,
      enableRecurringPaymentsOption:
        this.$appSettings.defaultConfigurations.payments.enableRecurringPaymentsOption,
      enableQuickPay: this.$appSettings.defaultConfigurations.fundTransferQuickPayEnabled,
      otpSettings: {
        resetPasswordTime:
          this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      enableAdditionalCommentsToFundsTransferRemarks:
        this.$appSettings.defaultConfigurations
          .enableAdditionalCommentsToFundsTransferRemarks,
      showOTPScreen: false,
      isLogout: false,
      formattedDate: '',
      repeatFormattedDate: '',
      currentTab: null,
      paymentMode: 0,
      payeeCurrentTab: 0,
      isTransferComplete: false,
      fetchIbanAccountId: '',
      isFromManagePayeeAccountIban: false,
      totalPayeeTabs: [
        this.$t('transferfunds.payeeOwnAccount'),
        this.$t('transferfunds.payeeAccount')
      ],
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        ackTXSV: {
          enabled: false,
          persistent: true,
          outlinedSaveBtn: false,
          outlinedCancelBtn: true,
          btn2Label: this.$t('transferfunds.backButton'),
          btn1Label: this.$t('transferfunds.proceed'),
          title: '',
          width: 367,
          btn1Callback: () => { this.currentTab === 0 ? this.nextValidate() : this.nextValidate('quickPayment') }
        },
        exceedISA: {
          enabled: false,
          persistent: true,
          outlinedSaveBtn: false,
          outlinedCancelBtn: false,
          cancelButton: this.$t('common.okay'),
          saveButton: '',
          title: this.$t('common.error'),
          width: 450
        }
      },
      quickPayment: {
        formattedDate: '',
        toAccount: '',
        isAccountBalance: false,
        fromDate: moment().format('YYYY-MM-DD'),
        reEnteredToAccount: '',
        selectedAccount: undefined,
        selectedAccountNumber: '',
        transferAmount: [],
        transferNote: '',
        isFormValid: false,
        toAccMaxLength: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? this.$appSettings.defaultConfigurations
          .fundTransferQuickPayToAccMaxlengthIBAN : this.$appSettings.defaultConfigurations
          .fundTransferQuickPayToAccMaxlength,
        isAccountInvalid: false
      },
      payeeForm: {
        toAccount: '',
        accountName: ''
      },
      totalFundTabs: [
        this.$t('transferfunds.registeredAccTitle'),
        this.$t('transferfunds.quickPaymentTitle')
      ],
      frequencyDays: [
        {
          state: this.$t('transferfunds.recurringPaymentFrequency.Daily'),
          val: 'DAILY'
        },
        {
          state: this.$t('transferfunds.recurringPaymentFrequency.Monthly'),
          val: 'MONTHLY'
        },
        {
          state: this.$t('transferfunds.recurringPaymentFrequency.BI-Monthly'),
          val: 'BI-MONTHLY'
        },
        {
          state: this.$t('transferfunds.recurringPaymentFrequency.Quarterly'),
          val: 'QUARTERLY'
        },
        {
          state: this.$t('transferfunds.recurringPaymentFrequency.Half-Yearly'),
          val: 'HALF-YEARLY'
        },
        {
          state: this.$t('transferfunds.recurringPaymentFrequency.Yearly'),
          val: 'YEARLY'
        }
      ],
      managePayee: false,
      beneficiaryList: [],
      currencyNotMatchingError: false,
      appSettings: this.$appSettings.defaultConfigurations.nominatedAccounts,
      noteRules: [
        (v) => !!v || 'Note is required',
        (v) => (v && v.length >= 5) || 'Note must be greater than 5 characters'
      ],
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredAmountRule: (v) =>
          (Boolean(v) && !!v.length) || this.$t('errors.common.amountRequired'),
        minValue: (v) =>
          v >= 2 || this.$t('transferfunds.numberOfPaymentsMinValidation'),
        maxValue: (v) =>
          v <= 10 || this.$t('transferfunds.numberOfPaymentsMaxValidation'),
        numberTypeCheck: (v) =>
          new RegExp('^\\d+(.\\d\\d?)?$').test(v) ||
          this.$t('errors.common.invalidInput'),
        isQuickPaymentBalanceValid: (v) => {
          let tempValue = v
          if (tempValue) {
            tempValue = tempValue.toString().replace(',', '.')
            return tempValue && tempValue > 0
              ? !this.quickPayment.isAccountBalance ||
              this.$t('transferfunds.fundsError')
              : new RegExp('^0*(.0*)$').test(tempValue)
                ? this.$t('errors.common.minAmountError')
                : false
          } else {
            return false
          }
        },
        isAccBalanceValid: (v) => {
          let tempValue = v
          if (tempValue) {
            tempValue = tempValue.toString().replace(',', '.')
            return tempValue && tempValue > 0
              ? !this.isAccountBalance || this.$t('transferfunds.fundsError')
              : new RegExp('^0*(.0*)$').test(tempValue) || tempValue < 0
                ? this.$t('errors.common.minAmountError')
                : false
          } else {
            return false
          }
        },
        isAlphaNumericRule: (v) => {
          if (v) {
            return (
              new RegExp(/^([^ !@#\\$%\\^&\\*][a-zA-Z0-9]*)$/g).test(v) || 'Invalid Format'
            )
          } else return 'Required Field'
        },
        invalidAmount: (v) => {
          if (v && v.length) {
            let pattern = /^\d*(\.\d{1,2})?$/
            const partyPreferredLocale = store.getters['profileStore/profileData'].preferredLocale
            if (partyPreferredLocale === 'de-DE') {
              pattern = /^\d*(,\d{1,2})?$/
            }
            return (
              pattern.test(v) || 'Invalid Format'
            )
          } else return 'Required Field'
        },
        remarksFieldRule: (v) => {
          if (!v) return true
          const regex = /^[a-zA-Z0-9][a-zA-Z0-9',.\s-]*$/
          const isValid = regex.test(v)
          return isValid || this.$t('errors.common.invalidInput')
        },
        remarksLengthRule: (v) => {
          if (!v) return true
          return v.length <= this.$appSettings.defaultConfigurations.payments.intraBank.remarksMaxLength || this.$t('transferfunds.noteError')
        }
      },
      text: {
        selectPayeeLabel: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? this.$t('transferfunds.selectPayeeLabelIBAN') : this.$t('transferfunds.selectPayeeLabel'),
        selectAccountLabel: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? this.$t('transferfunds.selectAccountLabelIBAN') : this.$t('transferfunds.selectAccountLabel'),
        reEnterToAccLabel: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? this.$t('transferfunds.reEnterToAccLabelIBAN') : this.$t('transferfunds.reEnterToAccLabel'),
        enterPayeeLabel: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? this.$t('transferfunds.enterPayeeLabelIBAN') : this.$t('transferfunds.enterPayeeLabel'),
        lisaAmountTooltipInfo: this.$t('transferfunds.lisaAmountTooltipInfo')
      },
      intraBankRemarksMaxlength: this.$appSettings.defaultConfigurations.payments.intraBank.remarksMaxLength,
      hideChgAmt: false,
      allowInactiveAccountTransactionalOperations: this.$appSettings.defaultConfigurations.allowInactiveAccountTransactionalOperations,
      profileStore: null,
      show: false,
      form: {
        selectedAccount: null,
        quickSelectedAccount: null
      },
      permissions: [],
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  async created () {
    this.profileStore = store.getters['profileStore/profileData']
    this.permissions = store.getters['profileStore/profileData']?.permissions
    if (!this.profileStore) {
      preload.getCustomerDetails(JSON.parse(sessionStorage.getItem('username')))
      this.profileStore = store.getters['profileStore/profileData']
    }

    const tomorrow = new Date()
    tomorrow.setDate(new Date().getDate() + 1)
    this.repeatMinAllowedDate = moment(tomorrow).format('YYYY-MM-DD')
    this.repeatFormattedDate = moment(tomorrow).format('YYYY-MM-DD')
    this.repeatFromDate = this.$formatter.formatDate(this.repeatFormattedDate)
    this.formattedDate = this.$formatter.formatDate(this.fromDate)
    this.quickPayment.formattedDate = this.$formatter.formatDate(
      this.todaysDate
    )
    this.listOfAccounts = await this.getListofAccounts()
    if (this.$route.params && this.$route.params.accountNumber) {
      this.selectedAccountNumber = this.$route.params.accountNumber
      this.quickPayment.selectedAccountNumber = this.$route.params.accountNumber
      this.selectedAccountType = this.$route.params.accountType
      this.selectedAccountNumberCurrency = this.$route.params.currency || ''
      this.verifyAccount()
      this.form.selectedAccount = {
        ...this.selectedAccount,
        selectedAccountText: formatSelectedAccount(this.selectedAccount),
        selectedAccountHintText: formatSelectedHint(this.selectedAccount)
      }
    }
    if (this.$route.params && this.$route.params.beneficiaryAccount) {
      this.payeeList = this.$route.params.beneficiaryAccount
      this.payeeAccount = this.$route.params.beneficiaryAccount
      this.toAccount = this.$route.params.beneficiaryReference
      this.isFromManagePayeeAccountIban = isNaN(this.$route.params.beneficiaryAccount)
      this.managePayee = true
    }
    if (this.loaderEnabled) this.loaderEnabled = false
    event.$on('is_TransferComplete', (status) => {
      this.isTransferComplete = status
      if (this.isTransferComplete) {
        this.isFormAccounts = false
        this.isFormAccountsQP = false
        this.selectedAccountNumber = ''
        this.payeeAccount = ''
      }
    })
    event.$on('open_userProfile', (isOpen) => {
      this.openPayee = false
    })
    event.$on('IS_REVIEW_CLEAR', ({ type }) => {
      this.reviewScreen = false
      this.createScreen = true
      if (type === 'Reset') {
        setTimeout(() => {
          this.resetPage()
        }, 100)
      }
      setTimeout(() => {
        event.$on('IS_OTP_VALID', this.otpValidHandler)
      }, 100)
    })
    event.$on('IS_OTP_VALID', this.otpValidHandler)
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
    if (!this.enableQuickPay) {
      this.currentTab = 0
    }
    if ((this.isSmeLogin && this.enableRoleBasedAccess) ? !this.permissions?.includes('VIEW_PAYEES') : false) {
      this.totalPayeeTabs.splice(1, 1)
    }
  },
  computed: {
    filteredSourceAccounts () {
      if (!this.listOfAccounts.length) return []
      const excludedMOO = this.$appSettings.uiFieldsDisplayConfigurations.jointModeOfOperationsForTransfer.exclusionList
      const sourceAccountsForRecurring = ['SVGS', 'CACC', 'TXEA']
      const isLisaStatusValid = (x) => x.accountType !== 'TXLA' || x?.lisaDetails?.lisaStatus === 'ACTIVE'

      return this.listOfAccounts
        .filter(account =>
          account.postingsRestriction !== 'DEBIT' &&
          account.accountType !== 'TXFR' &&
          (account.accountStatus !== 'INACTIVE' || this.allowInactiveAccountTransactionalOperations) &&
          (account.accountOwnership !== 'JOINT' || !excludedMOO.includes(account.modeOfOperation.code)) &&
          isLisaStatusValid(account) &&
          (!this.isRecurring || sourceAccountsForRecurring.includes(account.accountType))
        )
    },
    isPaymentDateEditAllowed () {
      return !this.isNotice(this.selectedAccountType) &&
        !this.isLisa(this.selectedAccountType) &&
        !this.isLisa(this.selectedPayee?.accountType)
    },
    settings () {
      const { payments } = this.$appSettings.defaultConfigurations
      return {
        allowPaymentsToOtherISA: payments.allowPaymentsToOtherISA,
        allowedSourceAccountTypesForLisaPayee: payments.allowedSourceAccountTypesForLisaPayee,
        lisaWithdrawalChargeEventNo: payments.lisaWithdrawalChargeEventNo
      }
    },
    isRecurring () {
      return this.paymentMode === 1
    },
    isOneTime () {
      return this.paymentMode === 0
    },
    lossOfInterestWarning () {
      const currency = this.penaltyDetails?.chargeAmount?.currency ?? this.penaltyDetails?.penaltyAmount?.currency ?? this.selectedAccountNumberCurrency
      return this.accruedPenaltyCharges
        ? this.$t('transferfunds.accruedPenaltyWarning', { amount: this.$formatter.currency.format(this.penaltyDetails?.penaltyAmount?.value, currency) })
        : this.$t('transferfunds.lossOfInterestWarning', { amount: this.$formatter.currency.format(this.chargeAmt, currency) })
    },
    isFutureDated () {
      const today = moment(this.todaysDate, 'YYYY-MM-DD')
      const fromDate = moment(this.fromDate, 'YYYY-MM-DD')
      return fromDate.isAfter(today)
    },
    age () {
      const today = moment(this.todaysDate, 'YYYY-MM-DD')
      const dateOfBirth = moment(this.profileStore.customerDetails.dateOfBirth, 'YYYY-MM-DD')
      return today.diff(dateOfBirth, 'years')
    },
    isQuickPayment () {
      return this.currentTab === 1
    },
    isOwnAccountsOpted () {
      return this.payeeCurrentTab === 0
    },
    selectedSource () {
      return this.isQuickPayment ? this.quickPayment.selectedAccount : this.selectedAccount
    },
    paymentAmount () {
      return this.isQuickPayment ? this.quickPayment.transferAmount : this.transferAmount
    }
  },
  methods: {
    otpValidHandler (val) {
      if (val && this.enableOTPToAddPayee && this.showOTPScreen) {
        this.modalConfig.otp.enabled = false
        this.addNewPayee()
      } else {
        this.modalConfig.otp.enableSave = true
      }
    },
    handleModalClose () {
      if (this.exceededTXNASubAmt || this.exceededTXFRSubAmt) {
        this.exceededTXNASubAmt = false
        this.exceededTXFRSubAmt = false
        this.modalConfig.exceedISA.enabled = false
      }

      if (this.confirmTXSVTransfer || this.confirmNACCTransfer) {
        this.confirmTXSVTransfer = false
        this.confirmNACCTransfer = false
        this.modalConfig.ackTXSV.enabled = false
        this.chargeAmt = 0
      }
    },
    async handleModalDisplay (acctType) {
      this.hideChgAmt = false
      this.modalConfig.ackTXSV.title = ''
      this.confirmTXSVTransfer = false
      this.confirmNACCTransfer = false

      if (this.sameTypeTaxAcc.includes(acctType)) {
        this.modalConfig.ackTXSV.cancelButton = this.$t('transferfunds.backButton')
        this.modalConfig.ackTXSV.saveButton = this.$t('transferfunds.proceed')
        this.modalConfig.ackTXSV.title = this.$t('transferfunds.ackConfirm')
        this.confirmTXSVTransfer = true
        this.modalConfig.ackTXSV.enabled = true
      }

      if (this.isNotice(acctType)) {
        this.modalConfig.ackTXSV.cancelButton = this.$t('closeAccount.btnCancel')
        this.modalConfig.ackTXSV.saveButton = this.$t('closeAccount.btnContinue')
        this.modalConfig.ackTXSV.title = this.$t('transferfunds.withdrawImmediately')
        this.penaltyDetails = await this.getPenaltyDetails()

        if (Array.isArray(this.penaltyDetails.causes) && 'code' in this.penaltyDetails.causes[0]) {
          if (this.penaltyDetails.causes[0].code === '40112540') {
            return
          }
          if (this.penaltyDetails.causes[0].code === '40205267') {
            this.handleNoticeWarningContinuation()
          }
        }

        if (this.penaltyDetails.status === 404 && this.penaltyDetails.detail === 'No Records Exist') {
          this.chargeAmt = this.$formatter.currency.customFormatter(0, this.selectedAccountNumberCurrency)
          this.hideChgAmt = true
          this.currentTab === 0 ? this.nextValidate() : this.nextValidate('quickPayment')
        }

        if (this.penaltyDetails?.chargeAmount && this.penaltyDetails?.taxAmount) {
          this.chargeAmt = +this.penaltyDetails.chargeAmount.value + +this.penaltyDetails.taxAmount.value
          this.confirmNACCTransfer = true
          this.modalConfig.ackTXSV.enabled = true
        }

        if (this.penaltyDetails?.penaltyAmount) {
          if (this.penaltyDetails?.penaltyAmount?.value > 0.00) {
            this.confirmNACCTransfer = true
            this.modalConfig.ackTXSV.enabled = true
          } else {
            this.handleNoticeWarningContinuation()
          }
        }
      }
    },
    async handleRefresh () {
      this.listOfAccounts = await this.getListofAccounts()
      if (this.loaderEnabled) this.loaderEnabled = false
    },
    filterKey (e) {
      const key = e.key
      if (key === '.' || key === 'e') {
        return e.preventDefault()
      }
    },
    restrictDecimal (val) {
      this.transferAmount = val
    },
    restrictCharacters (keyVal) {
      const partyPreferredLocale = store.getters['profileStore/profileData'].preferredLocale
      const excludeKeyCodes = [8, 37, 39]
      let pattern = /[0-9.]/
      if (partyPreferredLocale === 'de-DE') {
        pattern = /[0-9,]/
      }
      if (!pattern.test(keyVal.key) && !excludeKeyCodes.includes(keyVal.keyCode)) {
        keyVal.preventDefault()
      }
    },
    restrictDecimalForQuickPay (val) {
      if (val && val.length) {
        this.quickPayment.transferAmount = val
      }
    },
    resetPage () {
      // clears all fields
      if (this.$refs.quickPaymentForm) {
        this.quickPaymentToAccountErrorMsg = ''
        this.quickPayment.formattedDate = ''
        this.quickPayment.toAccount = ''
        this.quickPayment.isAccountBalance = false
        this.quickPayment.fromDate = moment().format('YYYY-MM-DD')
        this.quickPayment.reEnteredToAccount = ''
        this.quickPayment.selectedAccount = undefined
        this.quickPayment.isFormValid = false
        this.quickPayment.selectedAccountNumber = ''
        this.quickPayment.isAccountInvalid = false
        this.quickPayment.toAccMaxLength = this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? this.$appSettings.defaultConfigurations
          .fundTransferQuickPayToAccMaxlengthIBAN : this.$appSettings.defaultConfigurations
          .fundTransferQuickPayToAccMaxlength
        this.quickPayment.transferNote = ''
        this.quickPayment.transferAmount = ''
        this.$refs.quickPaymentForm.resetValidation()
        this.quickPayment.formattedDate = this.$formatter.formatDate(
          this.todaysDate
        )
      }
      if (this.$refs.form) {
        if (!this.quickPayment.selectedAccountNumber) {
          this.$refs.form.reset()
        } else {
          this.transferAmount = ''
          this.paymentFrequency = ''
          this.frequencyMonths = ''
          this.transferNote = ''
          this.toAccount = ''
          this.$refs.form.resetValidation()
        }
        this.selectedAccountType = ''
        this.fromDate = moment().format('YYYY-MM-DD')
      }
      this.managePayee = false
      // resets screens
      this.reviewScreen = false
      this.createScreen = true
      this.isFormValid = false
      this.isAccountBalance = false
      this.isTransferComplete = false
      this.quickPayment.isFormValid = false
      this.quickPayment.isAccountBalance = false
      this.openPayee = false
      this.payeeList = ''
      setTimeout(() => {
        this.resetDate()
        this.repeatResetDate()
      }, 100)
      this.menu = false
      this.toAccountIban = ''
      this.isInactiveNoticeCashISA = false
      this.exceededTXNASubAmt = false
      this.exceededTXFRSubAmt = false
      this.paymentMode = 0
    },
    onAddPayee (payeeFormData) {
      this.payeeForm.toAccount = payeeFormData.accountNumber
      this.payeeForm.accountName = payeeFormData.accountName
      if (this.enableOTPToAddPayee) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.addNewPayee()
      }
    },
    onOtpModalClose () {
      this.modalConfig.otp.enabled = false
      this.showOTPScreen = false
    },
    async addNewPayee () {
      try {
        const payeePayload = {
          customerId: JSON.parse(sessionStorage.getItem('username')),
          beneficiaryAccount: this.payeeForm.toAccount,
          beneficiaryReference: this.payeeForm.accountName
        }
        const response = await commonService.createIntraPayeeAccount(payeePayload)
        if (response && !response.causes && response.customerId) {
          this.onOtpModalClose()
          this.enablePayeeForm = false
          this.$store.dispatch('appStore/setAppData', {
            message: {
              content: this.$t('transferfunds.addPayeeSuccessMsg'),
              type: 'success',
              component: 'dob-snackbar'
            }
          })
          setTimeout(() => {
            this.getExistingPayeeList()
          }, 100)
        } else {
          if (response?.internalType === 'OTP-ERROR') {
            this.modalConfig.otp.enabled = true
            event.$emit('otp_validation_failed', response)
            return
          }
          this.onOtpModalClose()
        }
      } catch (e) {
        console.log(e)
      }
    },
    isNumberMatched (firstVal, secondVal) {
      return firstVal && secondVal ? firstVal !== secondVal : false
    },
    async getListofAccounts () {
      this.loaderEnabled = true
      const listOfAccounts = await preload.getAllCASAWithBalance(
        JSON.parse(sessionStorage.getItem('username'))
      )
      const updatedAccounts = await Promise.all(
        listOfAccounts.map(async x => {
          if (this.isLisa(x.accountType)) {
            const lisaDetails = await commonService.getLisaStatusDetails(x.accountId)
            return { ...x, lisaDetails }
          }
          return x
        })
      )

      return this.getFilteredAccounts(updatedAccounts)
    },
    allowedDates: (val) => parseInt(val.split('-')[2], 10) % 1 === 0,
    async getAccountBalances (accountNumber) {
      const response = await commonService.getAccountBalances(accountNumber)
      if (response.balances) {
        return response.balances
      }
    },
    listPayee () {
      this.openPayee = !this.openPayee
    },
    clearSearch () {
      this.search = ''
    },
    updateDate () {
      this.formattedDate = this.$formatter.formatDate(this.fromDate)
    },
    resetDate () {
      this.formattedDate = this.$formatter.formatDate(this.todaysDate)
    },
    repeatUpdateDate () {
      this.repeatFromDate = this.$formatter.formatDate(
        this.repeatFormattedDate
      )
    },
    repeatResetDate () {
      this.repeatFromDate = this.$formatter.formatDate(
        this.repeatMinAllowedDate
      )
      this.repeatFormattedDate = moment(
        moment(this.repeatFromDate, 'YYYY-MM-DD', true)
      ).isValid()
        ? this.repeatFromDate
        : this.repeatFromDate
          ? moment(this.repeatFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
          : ''
    },
    async verifyQuickPaymentPayee () {
      this.currencyNotMatchingError = false
      if (!this.quickPayment.toAccount.length) return

      const isIBANDisplayEnabled = this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay
      const beneficiary = isIBANDisplayEnabled ? await commonService.getCasaByIban(this.quickPayment.toAccount) : await commonService.fetchAccountDetails(this.quickPayment.toAccount)
      this.quickPayment.isAccountInvalid = !!beneficiary?.causes

      if (this.isLisa(beneficiary?.accountType)) {
        const lisaDetails = await commonService.getLisaStatusDetails(beneficiary.accountId)
        beneficiary.lisaDetails = lisaDetails
      }

      this.isCashISAAccount = !this.settings.allowPaymentsToOtherISA &&
        this.isCashIsa(this.quickPayment?.selectedAccount?.accountType) &&
        (this.isCashIsa(beneficiary?.accountType) ||
          beneficiary?.accountInformation?.productDescription.toLowerCase().includes('cash isa')
        )

      if (isIBANDisplayEnabled && beneficiary.basicInformation) {
        const accountInfo = await commonService.fetchAccountDetails(beneficiary.basicInformation.accountNumber)
        if (accountInfo.accountType && accountInfo.accountType === 'TXNA' && accountInfo.accountDescription.toLowerCase().includes('notice') && accountInfo.accountStatus.toLowerCase() === 'inactive') {
          this.isInactiveNoticeCashISA = true
        }
        return
      }

      if (beneficiary.currency !== this.selectedAccountNumberCurrency) {
        this.currencyNotMatchingError = beneficiary.currency ? true : ''
      }

      if (beneficiary.accountType && beneficiary.accountType === 'TXNA' && beneficiary.accountDescription.toLowerCase().includes('notice') && beneficiary.accountStatus.toLowerCase() === 'inactive') {
        this.isInactiveNoticeCashISA = true
      }

      const accountValidForLisaSource = () => this.form.quickSelectedAccount.accountType !== 'TXLA' ||
        this.$appSettings.defaultConfigurations.payments.allowedPayeeAccountTypesForLisaSource.includes(beneficiary.accountType)

      if (this.isCashISAAccount) {
        this.quickPaymentToAccountErrorMsg = this.$t('transferfunds.cashISAError')
      } else if (this.isInactiveNoticeCashISA) {
        this.quickPaymentToAccountErrorMsg = this.$t('transferfunds.inactiveNoticecashISAError')
      } else if (this.currencyNotMatchingError) {
        this.quickPaymentToAccountErrorMsg = this.$t('transferfunds.currencyNotMatchingError')
      } else if (this.quickPayment.isAccountInvalid) {
        this.quickPaymentToAccountErrorMsg = this.$t('transferfunds.quickPaymentToAccountErrorMsg')
      } else if (!this.isLisaPayeeAllowed(beneficiary)) {
        this.quickPaymentToAccountErrorMsg = this.$t('transferfunds.lifetimeNotAllowedAsBeneficiary')
      } else if (!accountValidForLisaSource()) {
        this.quickPaymentToAccountErrorMsg = this.$t('transferfunds.accountNotValidAsBeneficiaryForLifetimeSource')
      } else this.quickPaymentToAccountErrorMsg = ''
    },
    verifyAccount (triggeredFrom = undefined) {
      this.listOfAccounts.forEach((acc) => {
        const selectedType = this.selectedAccountNumber
          ? 'default'
          : 'quickPayment'
        switch (selectedType) {
          case 'quickPayment':
            if (this.quickPayment.selectedAccountNumber && acc.accountId === this.quickPayment.selectedAccountNumber) {
              const self = this
              this.selectedAccountNumberCurrency = acc.currency
              this.quickPayment.selectedAccount = acc
              self.isFormAccountsQP =
                self.quickPayment.selectedAccountNumber ===
                self.quickPayment.toAccount
              if (
                triggeredFrom !== 'selectPayee' &&
                triggeredFrom !== 'toAccount' &&
                this.quickPayment.transferAmount &&
                this.quickPayment.transferAmount.length
              ) {
                this.quickPayment.transferAmount = []
              }
              this.quickPayment.isAccountBalance = false
              if (triggeredFrom !== 'selectPayee' && triggeredFrom !== 'toAccount') {
                /** If we have a to account and when the user change the from account selection, clear the error related to cashisa in to account field, if any */
                if (self.quickPayment.selectedAccount && !this.isCashIsa(self.quickPayment.selectedAccount.accountType) && self.isCashISAAccount) self.isCashISAAccount = false
                /** If we have a to account, when from account is changed to a cash isa account run to account verify again */
                if (self.quickPayment.selectedAccount && this.isCashIsa(self.quickPayment.selectedAccount.accountType) && self.quickPayment.toAccount) this.verifyQuickPaymentPayee()
              }
            }
            break
          default:
            if (this.selectedAccountNumber && acc.accountId === this.selectedAccountNumber) {
              this.selectedAccountNumberCurrency = acc.currency
              this.selectedAccount = acc
              this.isFormAccounts = this.selectedAccountNumber === this.payeeAccount
              this.selectedAccountType = acc.accountType

              const isCashIsaPayeeAllowed = this.isCashIsaPayeeAllowed(this.toAccountType)
              if (!isCashIsaPayeeAllowed || !this.isLisaPayeeAllowed(this.selectedPayee)) {
                this.toAccount = ''
                this.toAccountIban = ''
                this.toAccountType = ''
                this.selectedPayee = null
              }

              if (
                triggeredFrom !== 'selectPayee' &&
                this.transferAmount &&
                this.transferAmount.length
              ) {
                this.transferAmount = []
              }
              this.isAccountBalance = false

              if (this.isNotice(this.selectedAccount.accountType) || this.isLisa(this.selectedAccount.accountType)) {
                this.formattedDate = this.$formatter.formatDate(this.minAllowedDate)
                this.fromDate = this.minAllowedDate
              }
            }
            break
        }
      })
    },
    verifyBalance () {
      const selectedType = this.selectedAccountNumber
        ? 'default'
        : 'quickPayment'
      switch (selectedType) {
        case 'quickPayment':
          this.quickPayment.transferAmount && this.quickPayment.transferAmount.toString().replace(',', '.') > 0 &&
          this.quickPayment.transferAmount.toString().replace(',', '.') <=
            (this.quickPayment.selectedAccount
              ? this.quickPayment.selectedAccount.balance
              : '')
            ? (this.quickPayment.isAccountBalance = false)
            : (this.quickPayment.isAccountBalance = true)
          break
        default:
          this.transferAmount.toString().replace(',', '.') > 0 &&
          this.transferAmount.toString().replace(',', '.') <=
            (this.selectedAccount ? this.selectedAccount.balance : '')
            ? (this.isAccountBalance = false)
            : (this.isAccountBalance = true)
          break
      }
    },
    async getCasaByIban (iban) {
      try {
        const response = await commonService.getCasaByIban(iban)
        if (response && response.basicInformation) {
          this.fetchIbanAccountId = response.basicInformation.accountNumber
        }
      } catch (e) {
        console.log(e)
      }
    },
    async isSubscriptionAmountExceeded (accountId, tfrAmount) {
      const subscriptionAmountDetails = await commonService.getTaxsavingsDetails(accountId)
      const amtRemaining = subscriptionAmountDetails.subscriptionAmount - subscriptionAmountDetails.subscriptionAmountUsed
      return amtRemaining - tfrAmount < 0
    },
    async nextValidate (type) {
      if (this.confirmTXSVTransfer) this.confirmTXSVTransfer = false
      if (this.quickPayment.reEnteredToAccount && this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay) {
        await this.getCasaByIban(this.quickPayment.reEnteredToAccount)
      }
      if (type === 'quickPayment') {
        const resp = await commonService.fetchAccountDetails(this.fetchIbanAccountId || this.quickPayment.reEnteredToAccount)
        if (['TXNA', 'TXFR'].includes(resp.accountType)) {
          const subscriptionAmountExceeded = await this.isSubscriptionAmountExceeded(resp.accountId, this.quickPayment.transferAmount)
          if (subscriptionAmountExceeded) {
            resp.accountType === 'TXNA' ? this.exceededTXNASubAmt = true : this.exceededTXFRSubAmt = true
            this.modalConfig.exceedISA.enabled = true
            return
          }
        }
      } else {
        if (['TXNA', 'TXFR'].includes(this.toAccountType)) {
          const subscriptionAmountExceeded = await this.isSubscriptionAmountExceeded(this.fetchIbanAccountId ? this.fetchIbanAccountId : this.payeeAccount, this.transferAmount)
          if (subscriptionAmountExceeded) {
            this.toAccountType === 'TXNA' ? this.exceededTXNASubAmt = true : this.exceededTXFRSubAmt = true
            this.modalConfig.exceedISA.enabled = true
            return
          }
        }
      }
      if (this.isFromManagePayeeAccountIban && this.payeeAccount) {
        await this.getCasaByIban(this.payeeAccount)
        this.toAccountIban = this.payeeAccount
      }
      this.createScreen = false
      this.isTransferComplete = false
      // check for empty strings (""), null, undefined, false and the numbers 0 and NaN
      if (!this.quickPayment.transferNote) {
        this.quickPayment.transferNote = ''
      }
      if (!this.transferNote) {
        this.transferNote = ''
      }
      let transferNoteBuilderQuick = ''
      let transferNoteBuilder = ''

      switch (type) {
        case 'quickPayment':
          if (this.$appSettings.defaultConfigurations.enableIBANAccountNarrative) {
            transferNoteBuilderQuick = this.enableAdditionalCommentsToFundsTransferRemarks
              ? this.$t('transferfunds.additionalCommentsToFundsTransferRemarks', {
                to: this.quickPayment.reEnteredToAccount,
                from: this.quickPayment.selectedAccount.iban
              }) + this.quickPayment.transferNote
              : this.quickPayment.transferNote
          } else {
            transferNoteBuilderQuick = this.enableAdditionalCommentsToFundsTransferRemarks
              ? this.$t('transferfunds.additionalCommentsToFundsTransferRemarks', {
                to: this.quickPayment.reEnteredToAccount,
                from: this.quickPayment.selectedAccountNumber
              }) + this.quickPayment.transferNote
              : this.quickPayment.transferNote
          }
          // trim the transfer text to 100 char if > 100
          if (transferNoteBuilderQuick.length > this.intraBankRemarksMaxlength) transferNoteBuilderQuick = transferNoteBuilderQuick.substring(0, 99)
          this.$refs.quickPaymentForm.validate()
          this.payload = {
            fromAcc: this.quickPayment.selectedAccountNumber,
            fromAccIban: this.quickPayment.selectedAccount.iban,
            toAcc: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? this.fetchIbanAccountId : this.quickPayment.reEnteredToAccount,
            toAccountWithType: this.quickPayment.reEnteredToAccount,
            transferAmount: this.quickPayment.transferAmount,
            paymentFrequency: 'ONCE',
            frequencyMonths: false,
            startDate: this.quickPayment.fromDate,
            transferNote: transferNoteBuilderQuick,
            fromAccount: this.form.quickSelectedAccount
          }
          this.viewOnly = {
            fromAccType: this.quickPayment.selectedAccount.accountType,
            toAccount: this.quickPayment.reEnteredToAccount,
            senderCurrency: this.selectedAccountNumberCurrency
          }
          break
        default:
          if (this.$appSettings.defaultConfigurations.enableIBANAccountNarrative) {
            transferNoteBuilder = this
              .enableAdditionalCommentsToFundsTransferRemarks
              ? this.$t('transferfunds.additionalCommentsToFundsTransferRemarks', {
                to: this.toAccountIban ? this.toAccountIban : this.payeeAccount,
                from: this.selectedAccount.iban ? this.selectedAccount.iban : this.selectedAccountNumber
              }) + this.transferNote
              : this.transferNote
          } else {
            transferNoteBuilder = this
              .enableAdditionalCommentsToFundsTransferRemarks
              ? this.$t('transferfunds.additionalCommentsToFundsTransferRemarks', {
                to: this.payeeAccount,
                from: this.selectedAccountNumber
              }) + this.transferNote
              : this.transferNote
          }
          // trim the transfer text to 100 char if > 100
          if (transferNoteBuilder.length > this.intraBankRemarksMaxlength) transferNoteBuilder = transferNoteBuilder.substring(0, 99)
          this.$refs.form.validate()
          this.selectedAccountNumber === this.payeeAccount
            ? (this.isFormAccounts = true)
            : (this.isFormAccounts = false)
          this.payload = {
            fromAcc: this.selectedAccountNumber,
            fromAccIban: this.selectedAccount.iban,
            toAcc: this.fetchIbanAccountId ? this.fetchIbanAccountId : this.payeeAccount,
            toAccountWithType: this.toAccount,
            transferAmount: this.transferAmount,
            paymentFrequency: this.isOneTime ? 'ONCE' : this.paymentFrequency.val,
            frequencyMonths: this.isOneTime ? false : this.frequencyMonths,
            startDate: this.isOneTime ? this.fromDate : this.repeatFormattedDate,
            transferNote: transferNoteBuilder,
            fromAccount: this.form.selectedAccount
          }
          this.viewOnly = {
            fromAccType: this.selectedAccount.accountType,
            senderAccName: this.payeeList,
            senderCurrency: this.selectedAccountNumberCurrency,
            toAccount: this.toAccount,
            toAccountType: this.toAccountType
          }
          break
      }

      if (this.isNotice(this.selectedSource.accountType) && !this.hideChgAmt) {
        this.viewOnly.chargeAmt = this.chargeAmt
        this.viewOnly.penaltyDetails = this.penaltyDetails
      }
      if (this.isLisa(this.selectedSource.accountType) && !this.selectedSource.lisaDetails.isCustomersAgeAboveLimit) {
        this.payload.lisaWithdrawalCharges = await this.getLisaWithdrawalCharges()
      }
      this.reviewScreen = true
    },
    isAnyInputsFilled () {
      if (this.currentTab === 1) {
        return Boolean(
          this.quickPayment.selectedAccountNumber ||
            this.quickPayment.toAccount ||
            this.quickPayment.reEnteredToAccount ||
            (this.quickPayment.transferAmount &&
              this.quickPayment.transferAmount.length)
        )
      } else {
        if (this.isRecurring) {
          return Boolean(
            this.selectedAccountNumber ||
              this.payeeList ||
              (this.transferAmount && this.transferAmount.length) ||
              this.paymentFrequency ||
              this.frequencyMonths
          )
        } else {
          return Boolean(
            this.selectedAccountNumber ||
              this.payeeList ||
              (this.transferAmount && this.transferAmount.length)
          )
        }
      }
    },
    async getExistingPayeeList () {
      try {
        const response = await commonService.getIntraBankPayeeList(
          JSON.parse(sessionStorage.getItem('username'))
        )
        if (response && response.beneficiaryList) {
          this.beneficiaryList = response.beneficiaryList
        }
      } catch (e) {
        console.log(e)
      }
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    handlePaymentModeChange () {
      this.selectedAccountType = ''
      this.selectedAccountNumberCurrency = ''
      this.selectedAccountNumber = ''
      this.selectedAccount = null
      this.form.selectedAccount = null
      this.form.quickSelectedAccount = null
    },
    async getPenaltyDetails () {
      try {
        const account = this.currentTab === 0 ? this.selectedAccountNumber : this.quickPayment.selectedAccountNumber
        const amount = this.currentTab === 0 ? this.transferAmount : this.quickPayment.transferAmount
        const accruedPayload = {
          transactionAmount: {
            value: parseFloat(amount),
            currency: this.selectedAccountNumberCurrency
          }
        }
        const penalty = this.accruedPenaltyCharges
          ? await commonService.getAccruedPenaltyCharges(account, accruedPayload)
          : await commonService.getNoticeLossOfInterest(account, amount)
        return penalty
      } catch (error) {
        console.error(error)
      }
    },
    isNotice (accountType) {
      return ['NACC', 'TXNA'].includes(accountType)
    },
    isLisa (accountType) {
      return accountType === 'TXLA'
    },
    handleNoticeWarningContinuation () {
      this.confirmNACCTransfer = false
      this.currentTab === 0 ? this.nextValidate() : this.nextValidate('quickPayment')
    },
    isCashIsa (accountType) {
      return ['TXSV', 'TXNA', 'TXFR', 'TXEA', 'TXLA'].includes(accountType)
    },
    isLisaPayeeAllowed (payee) {
      const { accountType = '', lisaDetails: { lisaStatus = '' } = {} } = payee || {}
      const isLisaStatusAllowed = ['OPEN', 'SUBSCRIBED', 'ACTIVE'].includes(lisaStatus)
      const sourceAccountType = this.isQuickPayment ? this.quickPayment?.selectedAccount?.accountType : this?.selectedAccountType
      const isSourceAllowed = this.settings.allowedSourceAccountTypesForLisaPayee.includes(sourceAccountType)

      return this.isLisa(accountType) ? isLisaStatusAllowed && isSourceAllowed : true
    },
    isCashIsaPayeeAllowed (beneficiaryAccountType) {
      return this.isCashIsa(this.selectedAccountType) && this.isCashIsa(beneficiaryAccountType)
        ? this.settings.allowPaymentsToOtherISA
        : true
    },
    onIntrabankPayeeSelected (item) {
      const { accountId, beneficiaryAccount, beneficiaryReference } = item
      this.payeeAccount = accountId || beneficiaryAccount
      this.payeeList = beneficiaryAccount
      this.toAccount = beneficiaryReference
      this.selectedPayee = item
      this.openPayee = false
      this.verifyAccount('selectPayee')
    },
    onOwnAccountPayeeSelected (item) {
      const { accountId, beneficiaryAccount, accountType, iban, accountDescription } = item
      this.payeeAccount = accountId || beneficiaryAccount
      this.toAccount = formatSelectedAccount(item)
      this.payeeList = formatSelectedHint(item)
      this.toAccountIban = iban
      this.toAccountType = accountType
      this.toAccountDesc = accountDescription
      this.selectedPayee = item
      this.openPayee = !this.openPayee
      this.verifyAccount('selectPayee')
    },
    onPayeeTabChanged () {
      if (!this.isOwnAccountsOpted) this.getExistingPayeeList()
    },
    validateQuickPaymentForm () {
      this.verifyAccount()
      this.verifyQuickPaymentPayee()
    },
    onPaymentTabChanged () {
      this.selectedAccount = null
      this.quickPayment.selectedAccount = null
      this.form.selectedAccount = null
      this.form.quickSelectedAccount = null
    },
    toDecimal (amount) {
      const number = Number(amount)
      if (isNaN(number)) {
        return NaN
      }
      return number.toFixed(2).toString()
    },
    async getLisaWithdrawalCharges () {
      const { selectedSource: s, settings: c, paymentAmount } = this

      const payload = {
        accountId: s.accountId,
        eventNo: c.lisaWithdrawalChargeEventNo,
        transactionAmount: {
          value: this.toDecimal(paymentAmount),
          currency: s.currency
        }
      }
      const response = await commonService.getEventCharges(payload)
      return response?.charges ?? []
    },
    dispatchError (title, content) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title,
          width: 400,
          persistent: true,
          saveButton: this.$t('common.okay'),
          content,
          type: 'error',
          component: 'dob-modal'
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isTransferComplete) {
      next()
    } else {
      const condition =
        this.currentTab === 1
          ? this.quickPayment.isFormValid
            ? this.isTransferComplete
            : this.reviewScreen
              ? false
              : !this.isAnyInputsFilled()
          : this.formValid
            ? this.isTransferComplete
            : this.reviewScreen
              ? false
              : !this.isAnyInputsFilled()
      if (!condition) {
        if (this.to) {
          next()
        } else if (this.isLogout) {
          this.to = to
          this.isLeavingRoute = false
          this.$router.push('/login')
        } else {
          this.to = to
          this.isLeavingRoute = true
        }
      } else {
        next()
      }
    }
  },
  watch: {
    'quickPayment.toAccount': function () {
      if (this.isCashISAAccount) this.isCashISAAccount = false
      if (this.isInactiveNoticeCashISA) this.isInactiveNoticeCashISA = false
    },
    'form.selectedAccount' () {
      this.selectedAccountNumber = this.form.selectedAccount?.accountId ?? ''
      this.selectedAccount = this.form.selectedAccount
      this.selectedAccountType = this.selectedAccount?.accountType ?? ''
      this.selectedAccountNumberCurrency = this.selectedAccount?.currency ?? ''
    },
    'form.quickSelectedAccount' () {
      this.quickPayment.selectedAccountNumber = this.form.quickSelectedAccount?.accountId ?? ''
      this.quickPayment.selectedAccount = this.form.quickSelectedAccount
      this.$nextTick()
    },
    currentTab () {
      if (this.openPayee) {
        this.openPayee = false
      }
      if (!this.managePayee) {
        this.resetPage()
      }
    },
    showOTPScreen () {
      if (this.enableOTPToAddPayee && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
  }
}
</script>
